module.exports = __webpack_public_path__ + "img/brands-codesandbox.24ac7ce8.svg";